module.exports = __webpack_public_path__ + "img/photo-0093.afdd0da6.jpg";